module.exports = __webpack_public_path__ + "static/media/mongodb.ebc8e5c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/mongodb.png
// module id = 49
// module chunks = 0